export default "__VITE_ASSET__39d6e768__"